import request from "@utils/request";

// 生成链接
export function generateLink() {
  return request.post("/card/generateLink", {}, {
    login: true
  });
}

export function cardCategoryList() {
  return request.post("/card/cardCategory/list", {}, {
    login: true
  });
}

// 创建游戏
export function createGame(data) {
  return request.post("/card/game/createGame", data, {
    login: true
  });
}

export function createPlayer(data) {
  return request.post("/card/player/createPlayer", data, {
    login: true
  });
}
export function getGameInfo(data) {
  return request.post("/card/check", data, {
    login: true
  });
}
// 获取已加入成员信息
export function getPlayerList(params) {
  return request.get("/card/player/list", params, {
    login: true
  });
}

// 开始 or 结束游戏

export function modifyGameStatus(data) {
  return request.post("/card/modifyGameStatus", data, {
    login: true
  });
}

// 根据卡牌ID获取卡牌列表

export function getCardList(params) {
  return request.get("/card/getCardList", params, {
    login: true
  });
}

// 添加游戏记录
export function gameRecordSave(data) {
  return request.post("/card/gameRecord/save", data, {
    login: true
  });
}

// 获取游戏记录
export function getGameRecord(gameId, playerId) {
  return request.get(`card/gameRecord/list/${gameId}`, {
    gameId,
    playerId
  }, {
    login: true
  });
}
// 教练进行下一轮发牌
export function generateNextRoundConfig(data) {
  return request.post("/card/round/generateNextRoundConfig", data, {
    login: true
  });
}

// 获取游戏列表
export function getGameList(data) {
  return request.post("/card/game/list", data, {
    login: true
  });
}

// 获取游戏最新一轮的配置信息
export function getRoundConfig(data) {
  return request.post("/card/getRoundConfig", data, {
    login: true
  });
}

// 用户退出游戏
export function exitGame(gameId) {
  return request.post(`/card/game/exit/${gameId}`, {
    gameId
  }, {
    login: true
  });
}

// 教练翻牌
export function openCard(data) {
  return request.post(`/card/player/open`, data, {
    login: true
  });
}

// 教练邀请
export function inviteMember(data) {
  return request.post(`/card/game/inviteMember`, data, {
    login: true
  });
}

// 教练获取当前游戏所有轮次
export function roundList(data) {
  return request.post(`/card/roundList/${data.gameId}`, data, {
    login: true
  });
}